import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import checkmark from './checkmark.svg';

export const SubmissionConfirmationPanel = ({
  submissionConfirmation,
  darUpdateString,
  backToDashboardString,
  goToDashboard,
}) => {
  return (
    <div className={styles.panel}>
      <div className={styles.submissionMessage}>
        <img alt="check mark" src={checkmark} className={styles.checkmark} />
        <div>
          <div className={styles.submissionConfirmation}>
            {submissionConfirmation}
          </div>
          <div>{darUpdateString}</div>
        </div>
      </div>
      <button onClick={goToDashboard} className={styles.button}>
        {backToDashboardString}
      </button>
    </div>
  );
};

export default enhance(SubmissionConfirmationPanel);
